// 获取文件预签名地址
export const getFilePresignedUrl = (path: string) =>
  useGet(
    "/api/v1/infra-server/file/presigned-url",
    { path },
    { timeout: 10000 }
  );

// 创建文件
export const createFile = (data: any) => {
  return usePost("/api/v1/infra-server/file/create", data, {
    disableCache: true,
  });
};

export const UploadUrl = "/api/v1/infra-server/file/presigned-url";

// 上传文件
export const updateFile = (data: any) => {
  if (!data) return;
  const formData = new FormData();
  formData.append("file", data);
  // 注意此处设置headersType并不是真的要让HTTP请求设置"Content-Type"，而是不做请求参数的预处理
  // 文件上传不能设置"Content-Type"为"multipart/form-data"，让浏览器自己识别FormData然后去做处理
  return usePost(UploadUrl, formData, {
    headersType: "multipart/form-data",
  });
};

// 获取临时文件下载地址;
export interface PresignedDownloadUrlParams {
  fileInfoList: {
    fileId: string;
    type: string;
    // resultUrl?: string;
    bizId?: string; // type -> 2 || type -> 3 时传模型id; type -> 5 时传打印配置id;
  }[];
}
export const presignedDownloadUrl = (params: PresignedDownloadUrlParams) =>
  usePost("/api/v1/model-library-server/common/presigned-download-url", params);

// 该文件是否首次下载; /api/v1/model-library-server/common/isFirstDownload
export interface IIsFirstDownloadParams {
  bizId: string;
  type: number; // 1模型; 2配置;
}
export const isFirstDownload = (params: IIsFirstDownloadParams) =>
  useGet("/api/v1/model-library-server/common/isFirstDownload", params);
